var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.4C21 8.27776 16.9706 9.8 12 9.8C7.02943 9.8 3 8.27776 3 6.4M21 6.4C21 4.52224 16.9706 3 12 3C7.02943 3 3 4.52224 3 6.4M21 6.4V9.8V11.5M3 6.4V9.8V11.5M21 11.5C21 13.3778 16.9706 15.4667 12 15.4667C7.02943 15.4667 3 13.3778 3 11.5M21 11.5V16.6C21 18.4778 16.9706 21 12 21C7.02943 21 3 18.4778 3 16.6V11.5",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.bc132e66b3cb675f293c00e835b34135.svg";
export { ForwardRef as ReactComponent };